import axios from 'axios';
import { showToast } from 'vant';
import WechatAuth from '@/utils/auth';

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL, // 基础URL，从环境变量中获取
  timeout: 15000, // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么，如添加token
    const token = WechatAuth.getToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    console.error('请求错误:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    return response.data;
  },
  (error) => {
    // 对响应错误做点什么
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 未授权，清除登录信息并提示重新登录
          console.error('未授权，请重新登录');
          showToast('登录已过期，请重新登录');
          WechatAuth.clearAuth();
          // 延迟跳转到首页触发重新登录
          setTimeout(() => {
            window.location.href = '/';
          }, 1500);
          break;
        case 403:
          console.error('拒绝访问');
          showToast('拒绝访问');
          break;
        case 404:
          console.error('请求地址不存在');
          showToast('请求的资源不存在');
          break;
        case 500:
          console.error('服务器内部错误');
          showToast('服务器错误，请稍后重试');
          break;
        default:
          console.error(`连接错误${error.response.status}`);
          showToast('网络请求失败');
      }
    } else if (error.code === 'ECONNABORTED') {
      console.error('请求超时');
      showToast('请求超时，请检查网络');
    } else {
      console.error('网络错误');
      showToast('网络连接失败，请检查网络');
    }
    return Promise.reject(error);
  }
);

export default service;
